/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IProgramLanguageData } from "Interfaces/SiteContent/IProgramLanguageData";

import {
  PROGRAM_LANGUAGE_LOAD,
  PROGRAM_LANGUAGE_LOAD_FAILURE,
  PROGRAM_LANGUAGE_LOAD_SUCCESS,
} from "./ProgramLanguageActionTypes";

/**
 * Action for getting the program language
 */
export interface IGetProgramLanguage {
  type: typeof PROGRAM_LANGUAGE_LOAD;
}

/**
 * Action getting the program language when successful
 */
export interface IGetProgramLanguageSuccess {
  type: typeof PROGRAM_LANGUAGE_LOAD_SUCCESS;
  programLanguages: IProgramLanguageData[];
}

/**
 * Action getting the program language when failure
 */
export interface IGetProgramLanguageFailure {
  type: typeof PROGRAM_LANGUAGE_LOAD_FAILURE;
  programLanguageLoadError: string;
}

/**
 * Action creator for getting the program language
 */
export const getProgramLanguage = (): ProgramLanguageActionTypes => ({
  type: PROGRAM_LANGUAGE_LOAD,
});

/**
 * Action creator for getting program language when success
 * @param programLanguages
 */
export const getProgramLanguageSuccess = (
  programLanguages: IProgramLanguageData[]
): ProgramLanguageActionTypes => ({
  type: PROGRAM_LANGUAGE_LOAD_SUCCESS,
  programLanguages,
});

/**
 * Action creator for getting program language when failure
 * @param ProgramLanguageLoadError
 */
export const getProgramLanguageFailure = (
  programLanguageLoadError: string
): ProgramLanguageActionTypes => ({
  type: PROGRAM_LANGUAGE_LOAD_FAILURE,
  programLanguageLoadError,
});

export type ProgramLanguageActionTypes =
  | IGetProgramLanguage
  | IGetProgramLanguageSuccess
  | IGetProgramLanguageFailure;
